import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetSummaryById = (data: any) =>
    request({
        url: ApiURL.Query.GetSummaryById,
        method: RequestType.POST,
        data,
    });

const SummaryQuery = {
    GetSummaryById,
};

export default SummaryQuery;
